import { useContext, forwardRef } from 'react'
import styled from 'styled-components'
import { TableContext } from '../..';
import { quarterNameBlockHeight, quarterNameBlockMarginBottom } from '../../utils/constants';
import { Row } from './row';

export const Rows = forwardRef<HTMLDivElement>((_, ref) => {
  const { teaserWithDateEvents } = useContext(TableContext);

  return (
    <RowsContainer ref={ref}>
      <Row teaser={teaserWithDateEvents} />
    </RowsContainer>
  )
})

const RowsContainer = styled.div`
  padding-top: calc(${quarterNameBlockHeight}px + ${quarterNameBlockMarginBottom}px);

  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-gap: 23px;
`

